import { render, staticRenderFns } from "./ContractorList.vue?vue&type=template&id=670ce2b7&scoped=true&"
import script from "./ContractorList.vue?vue&type=script&lang=ts&"
export * from "./ContractorList.vue?vue&type=script&lang=ts&"
import style0 from "./ContractorList.vue?vue&type=style&index=0&id=670ce2b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ce2b7",
  null
  
)

export default component.exports